export default "__VITE_ASSET__v0MF8oN5__"